"use client";

// @ts-ignore - TypeScript has issues with Radix UI exports
const PopoverPrimitive = require("@radix-ui/react-popover");
import * as React from "react";

import { cn } from "lib/utils";

const Popover = (
  { children, ...props }: React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Root> & { children?: React.ReactNode },
) => {
  return (
    <PopoverPrimitive.Root data-slot="popover" {...props}>
      {children}
    </PopoverPrimitive.Root>
  );
};

const PopoverTrigger = React.forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Trigger>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Trigger> & {
    children?: React.ReactNode;
    asChild?: boolean;
  }
>(({ children, ...props }, ref) => {
  return (
    <PopoverPrimitive.Trigger ref={ref} data-slot="popover-trigger" {...props}>
      {children}
    </PopoverPrimitive.Trigger>
  );
});
PopoverTrigger.displayName =
  PopoverPrimitive.Trigger.displayName || "PopoverTrigger";

function PopoverContent({
  className,
  align = "center",
  sideOffset = 4,
  children,
  ...props
}: React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content> & {
  children?: React.ReactNode;
}) {
  return (
    <PopoverPrimitive.Portal>
      <PopoverPrimitive.Content
        data-slot="popover-content"
        align={align}
        sideOffset={sideOffset}
        className={cn(
          "bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 w-72 origin-(--radix-popover-content-transform-origin) rounded-md border p-4 shadow-md outline-hidden",
          className,
        )}
        {...props}
      >
        {children}
      </PopoverPrimitive.Content>
    </PopoverPrimitive.Portal>
  );
}

const PopoverAnchor = React.forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Anchor>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Anchor> & {
    children?: React.ReactNode;
  }
>(({ children, ...props }, ref) => {
  return (
    <PopoverPrimitive.Anchor ref={ref} data-slot="popover-anchor" {...props}>
      {children}
    </PopoverPrimitive.Anchor>
  );
});
PopoverAnchor.displayName =
  PopoverPrimitive.Anchor.displayName || "PopoverAnchor";

export { Popover, PopoverTrigger, PopoverContent, PopoverAnchor };
